export default "__VITE_ASSET__d6a7edbe__"